<template>
    <div class="row">
        <div class="col-12 mb-2 text-lg text-blue-600 font-weight-bold">
            {{ $t('passenger') }} {{ idx + 1 }}
        </div>

        <div class="col-12 col-lg-4">
            <div class="mb-1" :class="{ 'is-required' : idx === 0 }">
                {{ $t('first_name') }}:
            </div>

            <div>
                <input class="form-control" :required="idx === 0" :value="passenger.first_name"
                    @input="onInput($event, 'first_name')"
                >
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="mb-1" :class="{ 'is-required' : idx === 0 }">
                {{ $t('last_name') }}:
            </div>

            <div>
                <input class="form-control" :required="idx === 0" :value="passenger.last_name"
                    @input="onInput($event, 'last_name')"
                >
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="mb-1" :class="{ 'is-required' : idx === 0 }">
                {{ $t('phone_number') }}:
            </div>

            <div>
                <phone-input
                    input-class="form-control"
                    :required="idx === 0"
                    :value="passenger.phone"
                    @input="onPhoneInput"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { updateClone } from '@utilities/object';

    export default {
        props: {
            passenger: {
                type: Object,
                required: true,
            },

            idx: {
                type: Number,
                required: true,
            },
        },

        methods: {
            updateValue(field, value) {
                const passenger = updateClone(this.passenger, field, value);

                this.$emit('update', this.idx, passenger);
            },

            onInput(event, field) {
                this.updateValue(field, event.target.value);
            },

            onPhoneInput(value) {
                this.updateValue('phone', value);
            },
        },
    };
</script>
